import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Menu from '@mui/material/Menu';
import { CircularProgress, IconButton } from '@mui/material';

import { VpIcon } from '@vp-ui/components';
import VpInfoMenuItem from '@vp-ui/components/VpInfoMenu/VpInfoMenuItem';

import { FeatureRenderer } from '@src/hoc/FeatureRenderer';
import { FEATURES } from '@src/plans-permissions';

export const VpInfoMenu = ({
  id,
  menuItems,
  onSelect,
  loading = false,
  optionalLabelValue = 'label',
  menuButton,
  children,
  IconButtonProps,
  MenuProps,
  prependItem = null,
  ...rest
}) => {
  const iconId = `more-button-${id}`;
  const menuId = `more-menu-${id}`;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };
  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setAnchorEl(null);
  };
  const onItemSelect = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    setAnchorEl(null);
    onSelect(item, e);
  };

  return (
    <>
      {loading ? (
        <CircularProgress size={24} />
      ) : (
        <IconButton
          id={iconId}
          aria-controls={open ? menuId : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          {...IconButtonProps}
        >
          {menuButton ? menuButton : <VpIcon icon="MoreVertical" />}
        </IconButton>
      )}
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableScrollLock
        MenuListProps={{
          'aria-labelledby': iconId,
        }}
        sx={{
          '& .MuiPaper-root': {
            minWidth: '220px',
          },
        }}
        {...MenuProps}
      >
        {prependItem}
        {children
          ? children
          : menuItems.map((item) =>
              item?.isFeature ? (
                <FeatureRenderer feature={FEATURES[item?.feature]} key={item?.id}>
                  <VpInfoMenuItem
                    key={item?.id}
                    item={item}
                    optionalLabelValue={optionalLabelValue}
                    onSelect={onItemSelect}
                    {...rest}
                  />
                </FeatureRenderer>
              ) : (
                <VpInfoMenuItem
                  key={item?.id}
                  item={item}
                  optionalLabelValue={optionalLabelValue}
                  onSelect={onItemSelect}
                  disabled={item?.disabled}
                  conditionalProps={item?.conditionalProps}
                  {...rest}
                />
              )
            )}
      </Menu>
    </>
  );
};

VpInfoMenu.propTypes = {
  onSelect: PropTypes.func,
  id: PropTypes.string,
  menuItems: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  optionalLabelValue: PropTypes.string,
  menuButton: PropTypes.node,
  children: PropTypes.node,
  IconButtonProps: PropTypes.object,
  MenuProps: PropTypes.object,
  prependItem: PropTypes.node,
};

export default VpInfoMenu;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpInfoMenu/VpInfoMenu.jsx